import { useLocation } from 'react-router-dom';
import { Button } from '@givebutter/primitives/button';
import * as CampaignModal from 'components/campaign-modal';
import * as CreateCampaignDialog from 'components/create-campaign-dialog';
import { NucleoIcon } from 'components/nucleo-icon';
import * as SidebarLink from 'components/sidebar/SidebarLink';
import { IntercomProductTourTargets } from 'constants/intercom';
import { TestIds } from 'constants/tests';
import { useCurrentAccount } from 'customHooks/useCurrentAccount';
import { useFlags } from 'launchdarkly-react-client-sdk';

const CampaignLinks = () => {
    const { newCampaignCreationOverlay = false } = useFlags();
    const { access, accountId } = useCurrentAccount();
    const location = useLocation();

    if (!access.pages.includes('campaigns')) return null;

    return (
        <div>
            <SidebarLink.Link
                to={`/accounts/${accountId}/campaigns`}
                data-testid={TestIds.Sidebar.CampaignsLink}
                data-intercom-target={IntercomProductTourTargets.SidebarCampaignsLink}
            >
                <SidebarLink.LevelOne
                    icon="bullhorn"
                    isActive={location.pathname === `/accounts/${accountId}/campaigns`}
                >
                    Campaigns
                </SidebarLink.LevelOne>
            </SidebarLink.Link>
            <div className="flex items-center gap-3 px-3 py-0.5 pt-1">
                <NucleoIcon icon="arrowTurnRight" className="text-gray-300" />
                {newCampaignCreationOverlay ? (
                    <CreateCampaignDialog.Root
                        triggerLocation={CreateCampaignDialog.TriggerLocation.SidebarNavNewCampaign}
                    >
                        <CreateCampaignDialog.Trigger asChild>
                            <Button
                                data-testid={TestIds.Sidebar.NewCampaignsButton}
                                variant="outline"
                                color="neutral"
                                size="xs"
                                className="hover:bg-gray-25 bg-gray-100 text-gray-600"
                                data-intercom-target={
                                    IntercomProductTourTargets.SidebarNewCampaignsButton
                                }
                            >
                                + New campaign
                            </Button>
                        </CreateCampaignDialog.Trigger>
                    </CreateCampaignDialog.Root>
                ) : (
                    <CampaignModal.Root>
                        <CampaignModal.Trigger asChild>
                            <Button
                                data-testid={TestIds.Sidebar.NewCampaignsButton}
                                variant="outline"
                                color="neutral"
                                size="xs"
                                className="hover:bg-gray-25 bg-gray-100 text-gray-600"
                                data-intercom-target={
                                    IntercomProductTourTargets.SidebarNewCampaignsButton
                                }
                            >
                                + New campaign
                            </Button>
                        </CampaignModal.Trigger>
                    </CampaignModal.Root>
                )}
            </div>
        </div>
    );
};

export { CampaignLinks };
